// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thankyou-page {
    height: calc(100vh - 70px); 
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .thankyou-content {
    text-align: center;
    background: rgba(255,255,255,0.85);
    padding: 40px 60px;
    border-radius: 12px;
    box-shadow: 0px 6px 20px rgba(0,0,0,0.15);
  }
  
  .thankyou-content h1 {
    font-size: 40px;
    margin-bottom: 10px;
  }
  
  .thankyou-content p {
    font-size: 18px;
    color: #333;
  }`, "",{"version":3,"sources":["webpack://./src/components/ThankYou/ThankYou.css"],"names":[],"mappings":"AAAA;IACI,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kCAAkC;IAClC,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,WAAW;EACb","sourcesContent":[".thankyou-page {\r\n    height: calc(100vh - 70px); \r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  .thankyou-content {\r\n    text-align: center;\r\n    background: rgba(255,255,255,0.85);\r\n    padding: 40px 60px;\r\n    border-radius: 12px;\r\n    box-shadow: 0px 6px 20px rgba(0,0,0,0.15);\r\n  }\r\n  \r\n  .thankyou-content h1 {\r\n    font-size: 40px;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .thankyou-content p {\r\n    font-size: 18px;\r\n    color: #333;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
